// @ts-nocheck
import { useFormik } from 'formik';
import Form from 'react-bootstrap/Form';
import { useCallback, useEffect, useState } from 'react';
import Select from 'react-select';
import {
  EditOrganization,
  cleanOrganization,
  getOrganization,
  getOrganizations
} from '@store/HR/Organizations/organizationSlice';
import { formOrganization } from '../../ValidationForm/validationSchema';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import useLookupOrgType from '@hooks/Lookups/use-Lookup-OrgType';
import useLookupOrgClass from '@hooks/Lookups/use-Lookup-OrgClass';
import useGetLocations from '@hooks/HRSetting/use-get-locations';
import Loading from '@components/Shared/Loader/Loading';
// import useGetChartAccountsDetailsList from '@hooks/Finance/useGetChartAccountsDetailsList';
import SwalAlert from '@components/Shared/Alert/SwalAlert';
import { DynamicInput } from './DynamicInput/DynamicInput';
import useGetOrganizations from '@hooks/HR/use-get-organizations';
import { Card, CardBody, CardHeader } from '@components/card/card';
import useGetPersons from '@hooks/HR/use-get-persons';

const Update = props => {
  const { type, onClose, id } = props;
  const [activeTab, setActiveTab] = useState('basic');

  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { ORG_TYPE } = useLookupOrgType();
  const { dataORGCLASS } = useLookupOrgClass();
  const { Locations } = useGetLocations();
  const { OperatingUnitOptions } = useGetOrganizations();
  const { loadingById, error, Organization } = useSelector(state => state.Organizations);
  // const { OptionsAccounts, loading: loadingAccounts } = useGetChartAccountsDetailsList();
  const { dataEmployees } = useGetPersons();

  // console.log(OptionsAccounts);

  useEffect(() => {
    dispatch(getOrganization(id));

    return () => {
      dispatch(cleanOrganization());
    };
  }, [dispatch, id]);


    const IsDisabled = Organization?.type === '30' // تعطيل التعديل اذا كان النوع شركة 


  const formik = useFormik({
    initialValues: {
      externalFlag: Organization ? Organization.externalFlag : false,
      InternalOrExternal: Organization?.externalFlag ? 'External' : 'Internal',
      name2: Organization ? Organization.name2 : '',
      name: Organization ? Organization.name : '',
      locationId: Organization ? Organization.locationId : '',
      dateFrom: Organization ? Organization.dateFrom : '',
      dateTo: Organization ? Organization.dateTo : '',
      description: Organization ? Organization.description : '',
      type: Organization ? Organization.type : '',
      organizationInformation: Organization ? Organization.organizationInformation : '',
      operatingUnitId: Organization ? Organization.operatingUnitId : '',
      code: Organization ? Organization.code : '',
      manegerId: Organization ? Organization.manegerId : '',
      parameters: Organization
        ? Organization?.parameters?.map(m => ({
            id: m.id,
            name: m.name,
            name2: m.name2,
            organizationClassification: m.organizationClassification,
            organizationType: m.organizationType,
            sequence: m.sequence,
            type: m.type,
            value:
              m.type === 'bool'
                ? m.value === '1'
                  ? true
                  : m.value === '0'
                    ? false
                    : m.value === null
                      ? 'null'
                      : m.value
                : m.value,
            category: m.category,
            filter: m.filter
          }))
        : []
    },

    enableReinitialize: true,
    validationSchema: formOrganization(t),

    onSubmit: (values, { resetForm }) => {
      // if (values.type === '30' && Organization.type !== '30') {
      // if (values.type === '30' ) {
      //   SwalAlert({
      //     icon: 'info',
      //     text: 'غيـر مسموح تعديل اعدادت الشركــة'
      //   });
      //   formik.setSubmitting(false);
      //   return;
      // }
      dispatch(
        EditOrganization({
          id: Organization.id,
          locationId: values.locationId || null,
          dateFrom: values.dateFrom,
          dateTo: values.dateTo || null,
          name: values.name,
          name2: values.name2,
          externalFlag: values.InternalOrExternal === 'External' ? true : false,
          description: values.description,
          type: values.type,
          organizationInformation: values.organizationInformation,
          operatingUnitId: values.operatingUnitId || null,
          code: values.code,
          manegerId: values.manegerId || null,
          parameters: values.parameters?.map(m => ({
            organizationCategoryId: m.id,
            parameterValue: m.type === 'bool' ? (m.value === true ? '1' : '0') : m.value
          }))
        })
      )
        .unwrap()
        .then(() => {
          onClose();
          CustomAlert({ action: 'Edit' });
          dispatch(getOrganizations());
        })
        .catch(error => {
          CustomAlert({
            action: 'Error',
            text: error.message || 'حدث خطأ أثناء التعديل'
          });
          formik.setSubmitting(false);
        });
    }
  });

  // جلب قيم معلومات الادارة  والوصول الى مسمياتها من خلال القيم
  const LabelArray =
    Organization &&
    formik.values.organizationInformation?.split(',')?.map(value => {
      const label = dataORGCLASS?.find(f => f.value === value.trim());
      return label;
    });

  const { values } = formik;

  // تجميع الـ parameters حسب الفئة
  const categorizedParams = values.parameters?.reduce((acc, param) => {
    const category = param.category || 'Other';
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(param);
    return acc;
  }, {});

  // الحصول على قائمة الفئات
  const categories = Object.keys(categorizedParams ?? {});

  // دالة لتحويل أسماء التبويبات
  const getTranslatedCategoryName = category => {
    const translations = {
      Purchase: {
        name2: ' المشتريات',
        name: 'Purchase Settings',
        description: '-',
        description2: '-'
      },
      Sales: {
        name2: ' المبيعات',
        name: 'Sales Settings',
        description: '-',
        description2: '-'
      },
      Fleet: {
        name: 'Fleet Settings',
        name2: ' الأسطول',
        description: '-',
        description2: '-'
      },
      Finance: {
        name: 'Finance Settings',
        name2: 'الإعدادات المالية',
        description: '-',
        description2: '-'
      },
      POS: {
        name: 'Point Of Sale',
        name2: 'نقاط البيـع',
        description: '-',
        description2: '-'
      },
      Inventory: {
        name: 'Inventory',
        name2: 'المخازن',
        description: '-',
        description2: '-'
      },
      Other: {
        name: 'Other',
        name2: 'أخرى',
        description: 'Additional Settings',
        description2: 'إعدادات إضافية'
      }
    };

    const translation = translations[category] || {
      name: category,
      name2: category,
      description: '',
      description2: ''
    };

    return translation;
  };

  

  const handleParamChange = useCallback(
    (param, value) => {
      let processedValue;

      if (['Account', 'Inventory', 'GL', 'Currency', 'Profile_Scale','Price_List'].includes(param?.type)) {
        processedValue = value === null ? null : value.value;
      } else {
        processedValue = value;
      }

      const updatedParameters = formik.values.parameters?.map(p =>
        p.id === param.id ? { ...p, value: processedValue } : p
      );

      formik.setFieldValue('parameters', updatedParameters);
    },
    [formik.values.parameters]
  );

  // الحصول على اسم النوع للمؤسسة
  const getOrganizationTypeName = () => {
    if (!Organization?.type) return '';

    let typeName = '';
    ORG_TYPE?.forEach(item => {
      const found = item.list?.find(list => list.lookupCode === Organization.type);
      if (found) {
        typeName = i18n.language === 'ar' ? found.meaning2 : found.meaning;
      }
    });
    return typeName;
  };




  // console.log(Organization);
  

  return (
    <>
      <Loading loading={loadingById} error={error}>
        {/* بطاقة عرض تفاصيل المؤسسة */}
        {Organization && (
          <Card className='mb-4'>
            <div className='card-body'>
              <div className='row g-2'>
                <div className='col-md-6'>
                  <h4 className='card-title'>{i18n.language === 'ar' ? Organization.name2 : Organization.name}</h4>
                  <div className='d-flex flex-wrap gap-2 mt-2'>
                    <span className='badge bg-primary'>{getOrganizationTypeName()}</span>
                    {LabelArray?.map(
                      (label, index) =>
                        label && (
                          <span key={index} className='badge bg-secondary'>
                            {i18n.language === 'ar' ? label.meaning2 : label.meaning}
                          </span>
                        )
                    )}
                  </div>
                </div>
                <div className='col-md-6 text-md-end'>
                  <div className=''>
                    <button
                      // disabled={formik.isSubmitting || !formik.dirty || IsDisabled}
                      disabled={formik.isSubmitting || !formik.dirty}
                      type='submit'
                      className='btn btn-theme mb-1 me-2'
                      onClick={() => formik.submitForm()}
                    >
                      {formik.isSubmitting ? (
                        <div className='spinner-border spinner-border-sm me-2'></div>
                      ) : (
                        <i className='fa fa-save fa-fw me-1'></i>
                      )}
                      {formik.isSubmitting ? t('Saving...') : t('Save')}
                    </button>
                    <button
                      type='button'
                      className='btn btn-default mb-1'
                      id='closeModal'
                      data-bs-dismiss='modal'
                      onClick={onClose}
                    >
                      <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        )}

        {/* تبويبات التنقل */}
        <ul className='nav nav-tabs mb-4 p-0 d-flex w-100' role='tablist'>
          <li className='nav-item flex-fill' role='presentation'>
            <button
              className={`nav-link w-100 fw-bold ${activeTab === 'basic' ? 'active' : ''}`}
              onClick={() => setActiveTab('basic')}
            >
              <i className='fa-lg bi bi-person-badge me-1'></i>
              {i18n.language === 'en' ? 'Basic Information' : 'البيانات الأساسية'}
            </button>
          </li>

          {categories.map(category => {
            console.log(category);
            
            const translatedCategory = getTranslatedCategoryName(category);
            return (
              <li key={category} className='nav-item flex-fill' role='presentation'>
                <button
                  className={`nav-link w-100 fw-bold ${activeTab === category ? 'active' : ''}`}
                  onClick={() => setActiveTab(category)}
                  title={translatedCategory.description}
                >
                  <i className='fa-lg bi bi-gear me-1'></i>
                  {i18n.language === 'en' ? translatedCategory.name : translatedCategory.name2}
                </button>
              </li>
            );
          })}
        </ul>

        <div className='tab-content'>
          <div className={`tab-pane fade ${activeTab === 'basic' ? 'show active' : ''}`}>
            <Card>
              <CardHeader>{i18n.language === 'en' ? 'Basic Information' : 'البيانات الأساسية'}</CardHeader>
              <CardBody>
                <Form onSubmit={formik.handleSubmit}>
                  <div className='row'>
                    {/* الصف الأول: الأسماء */}
                    <div className='col-xl-6'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>
                          {t('LocalName')} <span className='text-danger'>*</span>
                        </label>
                        <Form.Control
                          className='form-control'
                          type='text'
                          autoComplete='off'
                          name='name2'
                          onChange={formik.handleChange}
                          value={formik.values.name2 || ''}
                          isInvalid={formik.touched.name2 && formik.errors.name2}
                          placeholder={i18n.language === 'ar' ? 'الاسم المحلي' : 'Local name'}
                        />
                        <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
                      </div>
                    </div>

                    <div className='col-xl-6'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>
                          {t('GlobalName')} <span className='text-danger'>*</span>
                        </label>
                        <Form.Control
                          className='form-control'
                          type='text'
                          autoComplete='off'
                          name='name'
                          onChange={formik.handleChange}
                          value={formik.values.name || ''}
                          isInvalid={formik.touched.name && formik.errors.name}
                          placeholder={i18n.language === 'ar' ? 'الاسم العالمي' : 'Global name'}
                        />
                        <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
                      </div>
                    </div>

                    {/* الصف الثاني: الكود والموقع */}
                    <div className='col-xl-6'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>
                          {t('Code')} <span className='text-danger'>*</span>
                        </label>
                        <Form.Control
                          className='form-control'
                          type='text'
                          autoComplete='off'
                          name='code'
                          onChange={formik.handleChange}
                          value={formik.values.code || ''}
                          isInvalid={formik.touched.code && formik.errors.code}
                          placeholder={i18n.language === 'ar' ? 'كود المؤسسة' : 'Organization code'}
                        />
                        <Form.Control.Feedback type='invalid'>{formik.errors.code}</Form.Control.Feedback>
                      </div>
                    </div>

                    <div className='col-xl-6'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>
                          {t('location')} <span className='text-danger'>*</span>
                        </label>
                        <Form.Select
                          className='form-select'
                          name='locationId'
                          onChange={formik.handleChange}
                          value={formik.values.locationId || ''}
                          isInvalid={formik.touched.locationId && formik.errors.locationId}
                        >
                          <option value=''>{i18n.language === 'ar' ? 'إختر الموقع' : 'Choose location'}</option>
                          {Locations?.map(item => (
                            <option key={item.id} value={item.id}>
                              {i18n.language === 'ar' ? item.name2 : item.name}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type='invalid'>{formik.errors.locationId}</Form.Control.Feedback>
                      </div>
                    </div>

                    {/* الصف الثالث: النوع والمدير */}
                    <div className='col-xl-6'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>
                          {t('InternalOrExternal')} <span className='text-danger'>*</span>
                        </label>
                        <Form.Select
                          className='form-select'
                          name='InternalOrExternal'
                          onChange={formik.handleChange}
                          value={formik.values.InternalOrExternal}
                          isInvalid={formik.touched.InternalOrExternal && formik.errors.InternalOrExternal}
                        >
                          <option value=''>{i18n.language === 'ar' ? 'إختر النوع' : 'Choose type'}</option>
                          <option value='Internal'>{i18n.language === 'ar' ? 'داخلي' : 'Internal'}</option>
                          <option value='External'>{i18n.language === 'ar' ? 'خارجي' : 'External'}</option>
                        </Form.Select>
                        <Form.Control.Feedback type='invalid'>{formik.errors.InternalOrExternal}</Form.Control.Feedback>
                      </div>
                    </div>

                    <div className='col-xl-6'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('المدير / المسؤول')}</label>

                        <Select
                          classNamePrefix='react-select'
                          isSearchable={true}
                          isClearable
                          options={dataEmployees}
                          value={dataEmployees?.find(f => f.value === formik.values.manegerId) || null}
                          onChange={option => formik.setFieldValue('manegerId', option === null ? null : option?.value)}
                          placeholder={i18n.language === 'ar' ? 'إختر المدير' : 'Choose manager'}
                          // isLoading={loading}
                        />
                      </div>
                    </div>

                    {/* الصف الرابع: التواريخ */}
                    <div className='col-xl-6'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>
                          {t('Start Date')} <span className='text-danger'>*</span>
                        </label>
                        <Form.Control
                          type='date'
                          className='form-control'
                          name='dateFrom'
                          onChange={formik.handleChange}
                          value={formik.values.dateFrom || ''}
                          isInvalid={!!formik.errors.dateFrom}
                        />
                        <Form.Control.Feedback type='invalid'>{formik.errors.dateFrom}</Form.Control.Feedback>
                      </div>
                    </div>

                    <div className='col-xl-6'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('Date_TO')}</label>
                        <Form.Control
                          type='date'
                          className='form-control'
                          name='dateTo'
                          onChange={formik.handleChange}
                          value={formik.values.dateTo || ''}
                          min={formik.values.dateFrom}
                        />
                      </div>
                    </div>

                    {/* الصف الخامس: وحدة التشغيل والنوع */}
                    <div className='col-xl-6'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('OperationUnit')}</label>
                        <Select
                          classNamePrefix='react-select'
                          isSearchable={true}
                          isClearable
                          options={OperatingUnitOptions}
                          value={OperatingUnitOptions?.find(f => f.value === formik.values.operatingUnitId) || null}
                          onChange={option => formik.setFieldValue('operatingUnitId', option?.value)}
                          placeholder={i18n.language === 'ar' ? 'إختر وحدة التشغيل' : 'Choose operating unit'}
                        />
                      </div>
                    </div>

                    {!type && (
                      <div className='col-xl-6'>
                        <div className='form-group mb-3'>
                          <label className='form-label'>
                            {t('Type')} <span className='text-danger'>*</span>
                          </label>
                          <Form.Select
                            className='form-select'
                            name='type'
                            onChange={formik.handleChange}
                            value={formik.values.type || ''}
                            isInvalid={formik.touched.type && formik.errors.type}
                          >
                            <option value=''>{i18n.language === 'ar' ? 'إختر النوع' : 'Choose type'}</option>
                            {ORG_TYPE?.map(item =>
                              item.list?.map(list => (
                                <option key={list.lookupCode} value={list.lookupCode}>
                                  {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                                </option>
                              ))
                            )}
                          </Form.Select>
                          <Form.Control.Feedback type='invalid'>{formik.errors.type}</Form.Control.Feedback>
                        </div>
                      </div>
                    )}

                    {/* الصف السادس: الوصف */}
                    {/* <div className='col-12'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('Description')}</label>
                        <Form.Control
                          as='textarea'
                          rows={3}
                          className='form-control'
                          name='description'
                          onChange={formik.handleChange}
                          value={formik.values.description || ''}
                          placeholder={i18n.language === 'ar' ? 'وصف المؤسسة' : 'Organization description'}
                        />
                      </div>
                    </div> */}

                    {/* التصنيف */}
                    {!type && (
                      <div className='col-12'>
                        <div className='mb-3'>
                          <label className='form-label'>
                            {t('Classification')} <span className='text-danger'>*</span>
                          </label>
                          <Select
                            isMulti
                            options={dataORGCLASS}
                            classNamePrefix='react-select'
                            name='organizationInformation'
                            isSearchable={true}
                            value={LabelArray}
                            onChange={e => {
                              const formattedOptions = e?.map(option => option.value).join(',');
                              formik.setFieldValue('organizationInformation', formattedOptions);
                            }}
                            placeholder={i18n.language === 'ar' ? 'إختر التصنيفات' : 'Choose classifications'}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>

          {/* تبويبات الإعدادات الإضافية */}
          {categories?.map(category => {
            const translatedCategory = getTranslatedCategoryName(category);
            return (
              <div key={category} className={`tab-pane fade ${activeTab === category ? 'show active' : ''}`}>
                <Card>
                  <CardHeader>
                    {i18n.language === 'en' ? translatedCategory.name : translatedCategory.name2}
                    {translatedCategory.description && (
                      <small className='text-muted ms-2'>
                        ({i18n.language === 'en' ? translatedCategory.description : translatedCategory.description2})
                      </small>
                    )}
                  </CardHeader>
                  <CardBody>
                    <div className='row'>
                      {categorizedParams[category]
                        ?.sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0))
                        ?.map(param => (
                          <div className='col-xl-6' key={param.id}>
                            <DynamicInput
                              organizationId={id}
                              param={param}
                              value={formik.values.parameters?.find(p => p.id === param.id)?.value || ''}
                              onChange={value => handleParamChange(param, value)}
                            />
                          </div>
                        ))}
                    </div>
                  </CardBody>
                </Card>
              </div>
            );
          })}
        </div>
      </Loading>
    </>
  );
};

export default Update;
